import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import PhoneRotateIcon from '@mui/icons-material/ScreenRotation';

const LandscapeWarning = () => {
    const [isLandscape, setIsLandscape] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkOrientation = () => {
            const mobile = window.innerWidth <= 900; // Consider tablets too
            const landscape = window.innerHeight < window.innerWidth;
            
            setIsMobile(mobile);
            setIsLandscape(mobile && landscape);
        };

        // Check on mount
        checkOrientation();

        // Add event listeners for orientation and resize changes
        window.addEventListener('resize', checkOrientation);
        window.addEventListener('orientationchange', checkOrientation);

        return () => {
            window.removeEventListener('resize', checkOrientation);
            window.removeEventListener('orientationchange', checkOrientation);
        };
    }, []);

    if (!isMobile || !isLandscape) {
        return null;
    }

    return (
        <Box
            sx={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.95)',
                zIndex: 9999,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding: 4,
                textAlign: 'center'
            }}
        >
            <PhoneRotateIcon 
                sx={{ 
                    fontSize: 80, 
                    color: 'white', 
                    mb: 3,
                    animation: 'rotate 2s infinite ease-in-out',
                    '@keyframes rotate': {
                        '0%': { transform: 'rotate(0deg)' },
                        '50%': { transform: 'rotate(90deg)' },
                        '100%': { transform: 'rotate(90deg)' }
                    }
                }} 
            />
            <Typography 
                variant="h5" 
                sx={{ 
                    color: 'white', 
                    fontWeight: 'bold',
                    mb: 2
                }}
            >
                Please Rotate Your Device
            </Typography>
            <Typography 
                variant="body1" 
                sx={{ 
                    color: 'rgba(255, 255, 255, 0.8)',
                    maxWidth: '400px'
                }}
            >
                This app is best viewed in portrait mode. Please rotate your device to continue.
            </Typography>
        </Box>
    );
};

export default LandscapeWarning;

